'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('apiEndpointFactory', function(otppConstants, $q, $http, $cookies,$rootScope) {
  var API_HEADER_PREFIX = 'application/vnd.otpp.ms.mbrapi-v';
  var API_HEADER_SUFFIX = '+json;charset=UTF-8';
  var endpointCancelers=new Map();

  $rootScope.$on("cancelAllRequests",()=>{
    endpointCancelers.forEach((canceler,key)=>canceler.resolve());
    endpointCancelers.clear();
  });

  return {
    /**
     * Creates a new API endpoint.
     * @param {Object} args - object containing all configuration options.
     * @param {string} args.endpointUrl - the URL of the API endpoint
     * @param {string[]} args.allowedMethods - specifies which methods are
     *  allowed by the endpoint. Supports GET and POST currently.
     * @param {boolean} [args.isMemberApi] - should the API url
     *  '/members/my/api/members' be prepended to endpointUrl?
     * @param {boolean} [args.authRequired] - does the endpoint require a Token
     *  header?
     *  @param {string} args.apiVersion - the api version to call
     */
    new: function(args) {
      var url = '';
      if (args.isMemberApi === false) {
        url = args.endpointUrl;
      } else {
        url = otppConstants.apiUrl + args.endpointUrl;
      }

      var authRequired = args.authRequired || false;

      var apiVersion = args.apiVersion || false;

      var fileUpload = args.fileUpload || false;

      var allowed = {
        get: false,
        post: false
      };

      args.allowedMethods.forEach(function(val) {
        allowed[val.toLowerCase()] = true;
      });

      // We cannot use sessionService to get the token because it would cause a
      // circular dependency
      function getToken() {
        return $cookies.get(otppConstants.tokenStorageKey);
      }

      return {
        get: function(params, authToken) {
          if (!allowed.get) {
            return $q.reject('method not allowed');
          }

          var canceler=$q.defer();
          endpointCancelers.set(url,canceler);
          var httpArgs = {
            method: 'GET',
            url: url,
            headers: {},
            timeout:canceler.promise
          };

          if (params) {
            httpArgs.params = params;
          }

          if (authRequired) {
            var token = authToken || getToken();
            if (token) {
              httpArgs.headers['Authorization'] = 'Token ' + token;
            }
          }

          if (apiVersion) {
            httpArgs.headers['Accept'] = API_HEADER_PREFIX + apiVersion + API_HEADER_SUFFIX;
          }

          return $http(httpArgs);
        },
        post: function(data, authToken) {
          if (!allowed.post) {
            return $q.reject('method not allowed');
          }

          var canceler=$q.defer();
          endpointCancelers.set(url,canceler);
          var httpArgs = {
            method: 'POST',
            url: url,
            headers: {},
            timeout:canceler.promise
          };

          if (data) {
            httpArgs.data = angular.toJson(data);
          }

          if (authRequired) {
            var token = authToken || getToken();
            if (token) {
              httpArgs.headers['Authorization'] = 'Token ' + token;
            }
          }

          if (apiVersion) {
            httpArgs.headers['Accept'] = API_HEADER_PREFIX + apiVersion + API_HEADER_SUFFIX;
          }

          if (fileUpload) {
            httpArgs.headers['Content-Type'] = 'multipart/form-data';
          }

          return $http(httpArgs);
        }
      };
    }
  };
});
